import React from 'react'
import PhoneInputWithCountry from 'react-phone-number-input'
import { cn } from '@/lib/utils'

export type PhoneValue = string | undefined

type BaseProps = Omit<React.ComponentProps<typeof PhoneInputWithCountry>, 'value' | 'onChange'>

export interface PhoneInputProps extends BaseProps {
  value?: string
  onChange?: (value: PhoneValue) => void
  className?: string
}

export function PhoneInput({ value, onChange, className, ...props }: PhoneInputProps) {
  return (
    <PhoneInputWithCountry
      className={cn('slac-phone-input', className)}
      value={value}
      onChange={(nextValue) => onChange?.(nextValue as PhoneValue)}
      {...props}
    />
  )
}
